import { axiosPost, axiosGet } from '../../plugins/axios.plugins';

const API_ENDPOINTS = {
  FLOW_RUNNER: `${process.env.VUE_APP_FLOW_RUNNER_API}`,
};

export const runFlow = (url, payload) => {
  return axiosPost(
    `${url ? url : API_ENDPOINTS.FLOW_RUNNER}/run_flow`,
    payload
  );
};

export const runCode = (url, payload) => {
  return axiosPost(
    `${url ? url : API_ENDPOINTS.FLOW_RUNNER}/run_code`,
    payload,
    { customNotFoundRedirect: true }
  );
};

export const runFlowByID = (url, params = '', payload = {}, options = {}) => {
  return axiosPost(
    `${url ? url : API_ENDPOINTS.FLOW_RUNNER}/run_flow_by_id${params}`,
    payload,
    options
  );
};

export const calculateSpreadSheet = (url, payload = {}, options = {}) => {
  return axiosPost(
    `${url ? url : API_ENDPOINTS.FLOW_RUNNER}/spreadsheets/calculate`,
    payload,
    options
  );
};
